import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [input, setInput] = useState('');
  const fullText = 'Compare Q1 vs Q2 revenue';

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setInput(fullText.slice(0, i));
      i++;
      if (i > fullText.length) clearInterval(interval);
    }, 60);
    return () => clearInterval(interval);
  }, []);

  return (
    <section style={s.hero}>

      {/* LEFT */}
      <div style={s.left}>
        <h1 style={s.title}>
          Talk to Your Data. <br />
          <span style={s.gradient}>Get Instant Intelligence.</span>
        </h1>

        <p style={s.sub}>
          Connect databases or upload CSV files and ask questions in plain language.
          Generate insights, comparisons, and visual reports instantly.
        </p>

        <div style={s.ctaRow}>
          <Link to="/register" style={s.primary}>Start Exploring</Link>
          <Link to="/login" style={s.secondary}>See Live Demo</Link>
        </div>

        <div style={s.note}>
          No credit card required • Works with PostgreSQL, MySQL, SQLite & CSV
        </div>
      </div>

      {/* RIGHT (AI UI) */}
      <div style={s.right}>
        <div style={s.chatCard}>

          {/* Header */}
          <div style={s.chatHeader}>
           <div style={s.avatar}>
  <img src="/routa.png" alt="logo" style={s.avatarImg} />
</div>
            <div>
              <div style={s.botName}>DataSphere AI</div>
              <div style={s.status}>Online • Ready to analyze</div>
            </div>
          </div>

          {/* User message */}
          <div style={s.userMsg}>
            Show me top 5 products by revenue this quarter
          </div>

          {/* AI response */}
          <div style={s.aiBox}>
            <div style={s.aiTitle}>
              Here are your top 5 products by revenue for Q4 2025:
            </div>

            <div style={s.list}>
              <div>1. Enterprise Suite <span>$2.4M</span></div>
              <div>2. Pro Analytics <span>$1.8M</span></div>
              <div>3. Data Connect <span>$1.2M</span></div>
              <div>4. Cloud Storage <span>$890K</span></div>
              <div>5. API Gateway <span>$670K</span></div>
            </div>

            <div style={s.insight}>
              Revenue is up 23% compared to Q3
            </div>
          </div>

          {/* Input simulation */}
          <div style={s.input}>
            {input}
            <span style={s.cursor}>|</span>
          </div>

        </div>
      </div>

    </section>
  );
}
const s = {
  hero: {
    display: 'flex',
    padding: '120px 100px',
    alignItems: 'center',
    gap: 60,
    background: 'linear-gradient(135deg,#eef2ff,#f8fafc)',
  },

  left: { flex: 1 },
  right: { flex: 1 },

  title: {
    fontSize: 56,
    fontWeight: 800,
    lineHeight: 1.1,
    marginBottom: 20,
  },

  gradient: {
    background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },

  sub: {
    fontSize: 16,
    color: 'var(--text-muted)',
    marginBottom: 30,
    lineHeight: 1.6,
  },

  ctaRow: {
    display: 'flex',
    gap: 16,
    marginBottom: 16,
  },

  primary: {
    padding: '14px 24px',
    borderRadius: 12,
    background: 'linear-gradient(135deg,#4f46e5,#6366f1)',
    color: '#fff',
    textDecoration: 'none',
    fontWeight: 600,
  },

  secondary: {
    padding: '14px 24px',
    borderRadius: 12,
    border: '1px solid var(--border)',
    textDecoration: 'none',
  },

  note: {
    fontSize: 13,
    color: 'var(--text-muted)',
  },

  /* CHAT UI */
  chatCard: {
    background: '#fff',
    borderRadius: 20,
    padding: 20,
    boxShadow: '0 25px 70px rgba(0,0,0,0.08)',
  },

  chatHeader: {
    display: 'flex',
    gap: 12,
    marginBottom: 16,
  },

 avatar: {
  width: 40,
  height: 40,
  borderRadius: 10,
  background: 'rgba(99,102,241,0.1)', // softer instead of gradient
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
},

avatarImg: {
  width: 22,
  height: 22,
  objectFit: 'contain',
},

  botName: {
    fontWeight: 600,
  },

  status: {
    fontSize: 12,
    color: 'var(--text-muted)',
  },

  userMsg: {
    alignSelf: 'flex-end',
    background: '#6366f1',
    color: '#fff',
    padding: '10px 14px',
    borderRadius: 14,
    marginBottom: 16,
    maxWidth: '80%',
  },

  aiBox: {
    background: '#f8fafc',
    padding: 14,
    borderRadius: 14,
    marginBottom: 16,
  },

  aiTitle: {
    fontSize: 13,
    marginBottom: 10,
  },

  list: {
    fontSize: 13,
    lineHeight: 1.8,
  },

  insight: {
    marginTop: 10,
    fontSize: 12,
    color: '#6366f1',
  },

  input: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: '10px 12px',
    fontSize: 14,
    color: '#6366f1',
  },

  cursor: {
    marginLeft: 2,
    animation: 'blink 1s infinite',
  },
};